import { message, notification } from 'antd';
import { NotificationManager } from 'react-notifications';

export const NOTIFICATION_DURATION = {
    success: 5000,
    info: 7000,
    warning: 10000,
    error: 12000,
    long: 15000
};

const LONG_MESSAGE_LENGTH = 80;
let isConfigured = false;

const getContentText = (content) => {
    if (typeof content === 'string' || typeof content === 'number') {
        return String(content);
    }

    if (content && typeof content === 'object') {
        return getContentText(content.content || content.message || content.description);
    }

    return '';
};

export const resolveNotificationDuration = (type, content, persistent = false) => {
    if (persistent) return 0;

    const defaultDuration = NOTIFICATION_DURATION[type] || NOTIFICATION_DURATION.info;
    return getContentText(content).length >= LONG_MESSAGE_LENGTH
        ? Math.max(defaultDuration, NOTIFICATION_DURATION.long)
        : defaultDuration;
};

export const configureNotificationDurations = () => {
    if (isConfigured) return;
    isConfigured = true;

    // react-notifications dùng mili giây. Mọi thông báo vẫn có nút đóng thủ công.
    const originalCreate = NotificationManager.create.bind(NotificationManager);
    NotificationManager.create = (notify = {}) => {
        const persistent = notify.timeOut === 0;
        originalCreate({
            ...notify,
            timeOut: resolveNotificationDuration(notify.type, notify.message, persistent)
        });
    };

    // Ant Design dùng giây. Chuẩn hóa cả các lời gọi message trực tiếp trong page cũ.
    ['success', 'info', 'warning', 'error'].forEach((type) => {
        const originalMethod = message[type].bind(message);
        message[type] = (content, duration, onClose) => {
            const persistent = duration === 0 || (content && content.duration === 0);
            const durationInSeconds = resolveNotificationDuration(type, content, persistent) / 1000;

            if (content && typeof content === 'object' && !content.$$typeof) {
                return originalMethod({ ...content, duration: durationInSeconds });
            }

            return originalMethod(content, durationInSeconds, onClose);
        };
    });

    notification.config({ duration: NOTIFICATION_DURATION.info / 1000 });
};
